module.exports = __webpack_public_path__ + "img/album02_05.f75c38da.jpg";